import { useCurrentSnapshotCloudLicensing } from 'pages/SnapshotManagement/useCurrentSnapshotCloudLicensing';
import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type CloudLicensingGatedContentProps = {
  children: ReactNode;
};

/**
 * Leave pages that are only relevant for the new cloud licensing model when the current snapshot
 * does not support it. The menu hides them too (see `filterMenuTreeBySnapshotLicensing`); this
 * covers direct URL access. NIM-24746.
 */
export const CloudLicensingGatedContent: FC<
  CloudLicensingGatedContentProps
> = ({ children }) => {
  const supportsCloudLicensing = useCurrentSnapshotCloudLicensing();

  // `undefined` means nothing is known about the snapshot yet (snapshot list still loading) —
  // keep rendering, so that opening the page directly does not bounce before it arrives.
  if (supportsCloudLicensing === false) {
    return <Navigate to='/' replace />;
  }

  return children;
};
